import { z } from 'zod';
import {
  LedgerEntryStatusSchema,
  LedgerEntryTypeSchema,
} from '@triedge/students-families-domain';
import { ParentResourceTypeSchema } from '@triedge/staff-settings-domain';

export const ThreadStatusSchema = z.enum(['open', 'closed', 'archived']);
export type ThreadStatus = z.infer<typeof ThreadStatusSchema>;

export const SenderRoleSchema = z.enum(['parent', 'staff', 'system']);
export type SenderRole = z.infer<typeof SenderRoleSchema>;

export const MessageDirectionSchema = z.enum(['inbound', 'outbound']);
export type MessageDirection = z.infer<typeof MessageDirectionSchema>;

export const TransactionTypeSchema = LedgerEntryTypeSchema;
export type TransactionType = z.infer<typeof TransactionTypeSchema>;

export const TransactionStatusSchema = LedgerEntryStatusSchema;
export type TransactionStatus = z.infer<typeof TransactionStatusSchema>;

export const FormStatusSchema = z.enum(['not_started', 'in_progress', 'submitted', 'approved']);
export type FormStatus = z.infer<typeof FormStatusSchema>;

export const NotificationTypeSchema = z.enum(['info', 'warning', 'action_required']);
export type NotificationType = z.infer<typeof NotificationTypeSchema>;

export const ParentAccountStatusSchema = z.enum(['active', 'inactive', 'invited', 'suspended']);
export type ParentAccountStatus = z.infer<typeof ParentAccountStatusSchema>;

export { ParentResourceTypeSchema };
export type ParentResourceType = z.infer<typeof ParentResourceTypeSchema>;
